import Blocks from "./Blocks";

function App() {
  return (
    <Blocks/>
  );
}

export default App;
